import Components from "slotworks/components/components";
import Bet from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import BigWins from "slotworks/state-machine/standard/states/big-wins";

export default class RevolverBigWins extends BigWins {

    public complete() {
        this.setWinningsAfterBigWin(750);

        super.complete();
    }

    private setWinningsAfterBigWin(tickTime: number) {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const winnings = GameState.getCurrentGame().totalCreditsWon;

        if (record.beenPaid && Components.bigWin.isBigWin(winnings, Bet.getTotalBet())) {
            Components.betBar.winnings.setWinnings(0, winnings, tickTime);
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/states/revolver-big-wins.ts